const locale = {
    placeholder: 'Izberite čas',
};
export default locale;
